import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  InputBase,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { palette, useStylesGlobal } from "configurations/styles/theme";
import { useStylesApp } from "hooks/useStyles";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginBottom: "0.5%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular,
    color: palette.primary.menuHeader,
  },
  accordionSumary: {
    backgroundColor: palette.primary.light,
  },
  margin: {
    margin: theme.spacing(0),
    width: "100%",
    marginBottom: "1%",
  },
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(0),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);

const Farmaceutica = ({ detalleFarmaceutica, setDetalleFarmaceutica, errors, open, setOpen, dataFarmaceutica, setDataFarmaceutica }) => {
  const classes = useStyles();
  const classesGlobal = useStylesGlobal();
  const classesApp = useStylesApp();
  const handleChange = (event) => {
    setDetalleFarmaceutica({
      ...detalleFarmaceutica,
      [event.target.name]: event.target.value,
    })
  };
  const handleClickOpen = () => {
    if(dataFarmaceutica != null){
      setDetalleFarmaceutica(dataFarmaceutica)
    }
    if (open) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }
  return (
    <div className={classes.root}>
      <Accordion>
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon
            />
          }
          aria-controls="panel1a-content"
          id="panel1a-header"
          onClick={handleClickOpen}
        >
          <label className={classesGlobal.titleCard}>Medicinas y Materias primas Farmacéuticas: </label>
          <label className={classesGlobal.click}><label>{" "}</label> (Clic Aquí)</label>
        </AccordionSummary>
        <AccordionDetails>
          <from style={{ width: "100%" }}>

            <Grid item xs={12} md={12}>
              <label>Número de lote:</label> <font color={palette.error.main}>*</font>
            </Grid>
            <Grid item xs={12} md={12}>
              <input
                type="string"
                className="form-control"
                name="numeroLote"
                value={detalleFarmaceutica.numeroLote}
                onChange={handleChange}
              />
              {errors.numeroLote ? (
                <p className={classesApp.errorLetters}>
                  {errors.numeroLote}
                </p>
              ) : null}
            </Grid>

            <Grid item xs={12} md={12}>
              <label>Cantidad de productos en el lote:</label> <font color={palette.error.main}>*</font>
            </Grid>
            <Grid item xs={12} md={12}>
              <input
                type="string"
                className="form-control"
                name="cantidadProductos"
                value={detalleFarmaceutica.cantidadProductos}
                onChange={handleChange}
              />
              {errors.cantidadProductos ? (
                <p className={classesApp.errorLetters}>
                  {errors.cantidadProductos}
                </p>
              ) : null}
            </Grid>
          </from>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default Farmaceutica;
